import { date, required } from "utils/validate.util";
import { ReduxFormField } from "components/molecules/ReduxFormFields";
import SelectZoneClass from "components/organisms/SelectZoneClass";
import DateTimePickerRedux from "components/molecules/DateTimePickerRedux";
import SelectZone from "components/organisms/SelectZone/SelectZone";

export { default } from "./AddAvailabilityForm";

const toDate = (value?: string) => {
  if (!value) return null;
  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? null : parsed;
};

// Reported on the End Date field itself, so the message sits where the mistake
// is instead of as a line under the form.
const afterStartDate = (value: any, allValues: any) => {
  const start = toDate(allValues?.start_date?.date);
  const end = toDate(value?.date);
  if (!start || !end) return undefined;
  return end <= start ? "Must be after Start Date" : undefined;
};

export const fields: ReduxFormField[] = [
  {
    name: "zone_id",
    label: "Zone",
    validate: [required],
    component: SelectZone,
    // SelectProps: { disabledOnUpdate: true },
  },
  {
    name: "class_id",
    label: "Class",
    validate: [required],
    component: SelectZoneClass,
  },
  {
    name: "start_date",
    label: "Start Date",
    validate: [date],
    component: DateTimePickerRedux,
    DatePickerProps: {
      onChange: () => {},
      // minDate: new Date(),
      InputFieldProps: {},
      value: { date: "", error: false },
    },
  },
  {
    name: "end_date",
    label: "End Date",
    validate: [date, afterStartDate],
    component: DateTimePickerRedux,
  },
];
